<template>
  <div>
    <table class="table table-bordered">
      <tr>
        <th>Total Deposits:</th>
        <td class="text-right">{{ data.totalDepositsBGN }}</td>
      </tr>
      <tr>
        <th>Total Withdrawals:</th>
        <td class="text-right">{{ data.totalWithdrawalsBGN }}</td>
      </tr>
      <tr>
        <th>Total Commissions:</th>
        <td class="text-right">{{ data.totalCommissionsBGN }}</td>
      </tr>
      <tr>
        <th>Net Profit:</th>
        <td class="text-right">{{ data.netProfitBGN }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  props: ['data'],
}
</script>



// WEBPACK FOOTER //
// src/-service-app/components/tables/PortfolioTotalsTable.vue